import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// -------------------------------------------------------------------------
// PWA / Full-Screen detector (Feb 2026 — safe-area header fix).
// Adds `pwa-standalone` on <html> when the app is opened from a home-screen
// icon (iOS `navigator.standalone`) or in `display-mode: standalone /
// fullscreen`. CSS uses this class to shift the sticky header below the
// iPhone notch/status-bar so the ☰ and 🔔 remain tappable. Purely additive
// — normal browser mode is unaffected.
// -------------------------------------------------------------------------
(() => {
  const html = document.documentElement;
  const apply = () => {
    const isStandalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches ||
      window.matchMedia("(display-mode: fullscreen)").matches ||
      window.matchMedia("(display-mode: minimal-ui)").matches;
    html.classList.toggle("pwa-standalone", !!isStandalone);
  };
  apply();
  try {
    window.matchMedia("(display-mode: standalone)").addEventListener("change", apply);
  } catch { /* Safari <14 fallback */ }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
